module.exports = __webpack_public_path__ + "static/media/sk.e7c5539e.svg";